import { Component, Injector, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserRole } from '@services/auth/role.enum';
import { RolesService } from '@services/auth/role.service';
import { ModalService } from '@services/cleanfill-core/modal/modal.service';
import { StoreNotificationService } from '@services/cleanfill-core/store-notifications/store-notification.service';
import { StoreQpInvitationService } from '@services/cleanfill-core/store-qp-invitation/store-qp-invitation.service';
import { SearchQuery } from '@view-models/search-query/search-query';
import { NotificationListComponent } from '@widgets/path-common/notifications/notification-list/notification-list.component';
import { QpInvitationsComponent } from '@widgets/path-common/qp-invitations/qp-invitations.component';
import { filter, take } from 'rxjs/operators';
import { SidenavService } from '../side-nav/side-nav.service';

@Component({
  selector: 'top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
  showSiteSelector = false;
  UserRole = UserRole;
  isQPUser = false;
  constructor(
    public router: Router,
    private sidenavService: SidenavService,
    private rolesService: RolesService,
    private modal: ModalService,
    public notificationService: StoreNotificationService,
    public qpInvitationService: StoreQpInvitationService,
    private injector: Injector
  ) {
    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
      this.showSiteSelector = ['/', '/batches', '/dashboard'].includes((e as NavigationEnd).url);
    });
  }

  ngOnInit(): void {
    this.notificationService.loadNotifications();

    this.initInvitations();
  }
  async initInvitations() {
    this.isQPUser = await this.rolesService.isQPUser$.pipe(take(1)).toPromise();
    if (this.isQPUser) {
      const query = new SearchQuery().setPageIndex(undefined).setPageSize(undefined);
      this.qpInvitationService.loadQPInvitations(query);
    }
  }

  onViewNotifications() {
    this.sidenavService.open(NotificationListComponent, this.injector).then(t => {
      this.notificationService.clear();
    });
  }
  onViewInvitations() {
    this.modal.open(QpInvitationsComponent);
  }
}
